import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import { Container, ContainerWhite } from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import VideoBackground from '../../components/VideoBackground';
import TextPopper from '../../components/TextPopper';
import Scroller from '../../components/Scroller';

import Publicas from './modules/publicas';
import Vimeo from '../../components/Vimeo';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const SignIn: React.FC = () => {
  const history = useHistory();
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [cardLayout, setCardLayout] = useState([] as Array<JSX.Element>);

  const handleSubmit = useCallback(
    async (data: SignInData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Email obrigatório')
            .email('Preencha um email válido'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, { abortEarly: false });

        const { email, password } = data;

        await signIn({ email, password });
        history.push('/dashboard');
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Ocorreu um erro ao fazer login',
        });
      }
    },
    [signIn, addToast, history],
  );

  const buildCard: React.FC<IPublicData> = ({ icon, title, text }) => {
    return (
      <div
        onClick={() =>
          setCardLayout([<Publicas icon={icon} text={text} title={title} />])}
      >
        {icon({})}
        <p>{title}</p>
      </div>
    );
  };

  return (
    <>
      <ContainerWhite id="sobre">
      <div className="p50 p600">

<h2> APRESENTAÇÃO</h2>
<p>A primeira Jornada Latino-Americana de Emergências Pediátricas do HCPA realizada em 2017, foi um grande desafio, porque a proposta era fazer um evento diferenciado, com temas atuais e atividades dinâmicas, proporcionando integração entre os assuntos abordados, participantes e palestrantes. 
<br/><br/>Além disso, a Jornada foi um marco importante, pois foi o primeiro evento da área após o reconhecimento da Medicina de Emergência como uma especialidade, no final de 2015.
<br/><br/>O evento superou as expectativas e deixou um gostinho de quero mais... mal tinha terminado a primeira edição e a segunda já estava sendo programada.
Assim tem sido todos os anos: o envolvimento e o engajamento só aumentam, fazendo com que a Jornada seja o reflexo de cada um dos seus participantes. 
<br/><br/>Nesta terceira edição, temos muitas novidades e ainda mais desafios. Em meio 	à pandemia da covid-19 vamos fazer uma Jornada digital, mantendo a mesma energia e o desejo de que seja um evento atraente e dinâmico. A Emergência Pediátrica do HCPA está de casa nova e queremos mostrar para vocês essa estrutura que, com certeza, é uma referência. Entre tantos temas possíveis para debate, tivemos que escolher os que consideramos mais relevantes neste momento. Esperamos ter acertado! 
<br/><br/>Estamos nos adaptando a essa nova realidade e trabalhando com o mesmo carinho e dedicação de sempre, para junto com vocês, fazer um baita evento.
Saudações!<br/><br/>

Patrícia e Joca</p>

 </div>

 <div className="p50">



<div style={{maxWidth: '400px',margin:'20px auto'}}>

<strong> Coordenador:</strong>
<p>João Carlos Batista Santana</p>
<br/>
<strong>Coordenadora adjunta:</strong>
<p>Patricia Miranda do Lago</p>
<br/>
<strong>Organização:</strong>
<p>Coordenadoria de Comunicação do HCPA<br/>
Fundação Médica do Rio Grande do Sul</p>

<Vimeo id="469445751" keyName="video1-sobre"/>
<Vimeo id="469445726" keyName="video2-sobre"/>
</div>


   </div>
      </ContainerWhite>
    </>
  );
};
export default SignIn;
